import { Api } from '../api';
import { users } from '../endpoints';
import type { ApiResponse, ApiPaginate } from '@shared/api';
import type {
  AddUserAccountsRequest,
  AddUserCardsRequest,
  CreateUserRequest,
  DeleteUserAccountsRequest,
  DeleteUserCardsRequest,
  GenerateCodeRequest,
  GenerateCodeResponse,
  GetAccountUsersRequest,
  GetAccountUsersResponse,
  UpdatePasswordRequest,
  UserProfileResponse,
  UsersRequest,
  UserResponse,
  UserUpdateRequest,
  UserUpdateWithIdRequest,
} from './models';

export class UsersApi extends Api {
  static getUsers = (request: UsersRequest, signal?: AbortSignal) =>
    this.get<ApiPaginate<UserResponse[]>>({ url: users.getUsers(), queryParams: request, signal });

  static getUser = (id: string, signal?: AbortSignal) => this.get<ApiResponse<UserResponse>>({ url: users.getUser(id), signal });

  static updateUser = (request: UserUpdateWithIdRequest, signal?: AbortSignal) =>
    this.put<UserUpdateRequest, ApiResponse<UserResponse>>({ url: users.updateUser(request.id), data: request.request, signal });

  static lockUser = (id: string, signal?: AbortSignal) => this.put<null, ApiResponse<UserProfileResponse>>({ url: users.lockUser(id), signal });

  static unlockUser = (id: string, signal?: AbortSignal) => this.put<null, ApiResponse<UserProfileResponse>>({ url: users.unlockUser(id), signal });

  static deleteUser = (id: string) => this.delete<null, ApiResponse<null>>({ url: users.deleteUser(id) });

  static updatePassword = (request: UpdatePasswordRequest, signal?: AbortSignal) =>
    this.put<UpdatePasswordRequest, ApiResponse<UserProfileResponse>>({ url: users.updatePassword(), data: request, signal });

  static addUserAccounts = (request: AddUserAccountsRequest, signal?: AbortSignal) =>
    this.put<AddUserAccountsRequest, ApiResponse<UserProfileResponse>>({ url: users.addUserAccounts(), data: request, signal });

  static deleteUserAccounts = (request: DeleteUserAccountsRequest, signal?: AbortSignal) =>
    this.delete<DeleteUserAccountsRequest, ApiResponse<UserProfileResponse>>({ url: users.deleteUserAccounts(), data: request, signal });

  static generateCode = (request: GenerateCodeRequest, signal?: AbortSignal) =>
    this.put<GenerateCodeRequest, ApiResponse<GenerateCodeResponse>>({ url: users.degenerateCode(), data: request, signal });

  static addUserCards = (request: AddUserCardsRequest, signal?: AbortSignal) =>
    this.put<AddUserCardsRequest, ApiResponse<UserResponse>>({ url: users.addUserCards(), data: request, signal });

  static deleteUserCards = (request: DeleteUserCardsRequest, signal?: AbortSignal) =>
    this.delete<DeleteUserCardsRequest, ApiResponse<UserProfileResponse>>({ url: users.deleteUserCards(), data: request, signal });

  static addUser = (request: CreateUserRequest) => this.post<CreateUserRequest, ApiResponse<UserResponse>>({ url: users.getUsers(), data: request });

  static getAccountUsers = (request: GetAccountUsersRequest, signal?: AbortSignal) =>
    this.get<ApiPaginate<GetAccountUsersResponse[]>>({ url: users.getUsers(), queryParams: request, signal });
}
